import { render, staticRenderFns } from "./InfoEduStandart.vue?vue&type=template&id=2026f33c"
import script from "./InfoEduStandart.vue?vue&type=script&lang=js"
export * from "./InfoEduStandart.vue?vue&type=script&lang=js"
import style0 from "./InfoEduStandart.vue?vue&type=style&index=0&id=2026f33c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports